const DEFAULT_PLACEHOLDER = '-';

/**
 * Returns the value when non-empty, otherwise the "-" placeholder.
 *
 * Generic counterpart of displayPaymentValue for any block/invoice field that may
 * arrive empty from soft-validated reconstruction (read flows tolerate corrupt
 * backend data and surface it as an empty field).
 *
 * @param value - Raw field value from a view DTO
 * @returns The value or the default placeholder when empty
 */
export const displayValue = (value: string | null | undefined): string => value?.trim() || DEFAULT_PLACEHOLDER;
